// src/pages/Admin/ProgramCategoriesEdit.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import EditConfirmationModal from '../../components/common/EditConfirmationModal';
import TitleWithBack from '../../components/common/TitleWithBack';

function ProgramCategoriesEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categoryName, setCategoryName] = useState('');
  const [categoryCode, setCategoryCode] = useState('');
  const [description, setDescription] = useState('');
  const [tooltip, setTooltip] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    axios.get(`/api/program-categories/${id}`)
      .then(response => {
        setCategoryName(response.data.name);
        setCategoryCode(response.data.code);
        setDescription(response.data.description);
      })
      .catch(() => {
        setTooltip('Error fetching category details.');
      });
  }, [id]);

  const updateCategory = () => {
    const payload = { name: categoryName, code: categoryCode, description };
    axios.put(`/api/program-categories/${id}`, payload)
      .then(() => {
         setTooltip('Category updated successfully!');
         setTimeout(() => navigate('/admin/program-categories/view'), 2000);
      })
      .catch(() => {
         setTooltip('Error updating category.');
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Program Category" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Category Name</label>
              <input 
                type="text" 
                className="form-control"
                value={categoryName} 
                onChange={(e) => setCategoryName(e.target.value)}
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Code</label>
              <input 
                type="text" 
                className="form-control"
                value={categoryCode} 
                onChange={(e) => setCategoryCode(e.target.value)}
                required 
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <input 
                type="text" 
                className="form-control"
                value={description} 
                onChange={(e) => setDescription(e.target.value)}
                required 
              />
            </div>
            <button type="submit" className="btn btn-primary">Update Category</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
      {showConfirm && (
        <EditConfirmationModal 
          title="Confirm edit"
          message="Are you sure you want to edit this category?"
          onConfirm={() => { setShowConfirm(false); updateCategory(); }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default ProgramCategoriesEdit;
